var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1339 12.9342C25.1339 11.9244 25.0408 11.1839 24.8548 10.3984H12.811V14.9987H19.8792C19.7397 16.1432 18.9724 17.8486 17.2519 19.0155L17.2286 19.1726L21.0417 22.0226L21.2975 22.045C23.7388 19.8907 25.1339 16.7042 25.1339 12.9342Z",
    fill: "#4877BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8109 25.0485C16.2752 25.0485 19.1815 23.9489 21.2973 22.0415L17.2517 19.012C16.159 19.7301 14.7174 20.2463 12.8109 20.2463C9.41629 20.2463 6.53322 18.092 5.51019 15.1074L5.37069 15.1299L1.41809 18.092L1.37158 18.2266C3.46414 22.2659 7.78875 25.0485 12.8109 25.0485Z",
    fill: "#21A849"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51039 15.1127C5.23139 14.3498 5.09188 13.5195 5.09188 12.6667C5.09188 11.814 5.25464 10.9837 5.51039 10.2207V10.0637L1.51129 7.05664L1.37178 7.12397C0.511512 8.807 0 10.692 0 12.6892C0 14.6864 0.488261 16.5714 1.37178 18.2544L5.51039 15.1127Z",
    fill: "#FBBA10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8112 5.08058C15.2292 5.08058 16.8335 6.0904 17.7635 6.9207L21.3906 3.50975C19.1586 1.51256 16.2755 0.300781 12.8112 0.300781C7.78905 0.300781 3.46444 3.08339 1.34863 7.12266L5.48724 10.2419C6.53351 7.23486 9.41659 5.08058 12.8112 5.08058Z",
    fill: "#E73830"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.527ac41f1ae6239f48ee97b6096b6367.svg";
export { ForwardRef as ReactComponent };